import React from "react";
import { ShieldCheck, ScaleIcon, HeartHandshake } from "lucide-react";
import { HERO_BG_IMAGE } from "./constants";

export const Hero = () => (
    <section
        id="inicio"
        className="lf-hero-pattern lf-hero-with-image"
        style={{
            backgroundImage: `linear-gradient(135deg, rgba(0,58,105,0.82) 0%, rgba(0,40,74,0.88) 55%, rgba(0,28,52,0.92) 100%), url('${HERO_BG_IMAGE}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}
        data-testid="hero-section"
    >
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36">
            <div className="relative z-10 max-w-4xl mx-auto text-center">
                <div
                    className="lf-fade-up inline-flex items-center gap-2 mb-8 px-4 py-1.5 rounded-full border"
                    style={{
                        borderColor: "rgba(244, 196, 48, 0.35)",
                        backgroundColor: "rgba(244, 196, 48, 0.08)",
                    }}
                    data-testid="hero-pill"
                >
                    <span
                        className="w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: "var(--lf-gold-light)" }}
                    />
                    <span
                        className="text-[11px] font-semibold uppercase tracking-[0.18em]"
                        style={{ color: "var(--lf-gold-light)" }}
                    >
                        Gobierno del Estado Falcón · República Bolivariana de Venezuela
                    </span>
                </div>

                <h1
                    className="lf-fade-up lf-delay-1 text-white font-extrabold tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05]"
                    data-testid="hero-title"
                >
                    ¡Juega seguro,{" "}
                    <span
                        style={{
                            background:
                                "linear-gradient(90deg, #ffffff 0%, #e2e8f0 50%, #ffffff 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        juega Falcón!
                    </span>
                </h1>

                <div className="lf-fade-up lf-delay-2 flex justify-center mt-8">
                    <div className="lf-gold-divider" />
                </div>

                <p
                    className="lf-fade-up lf-delay-2 mt-8 text-base sm:text-lg lg:text-xl text-slate-200 leading-relaxed max-w-3xl mx-auto"
                    data-testid="hero-subtitle"
                >
                    Regulación, transparencia y bienestar social a través de la
                    gestión eficiente de la actividad de juegos de lotería.
                </p>

                <div
                    className="lf-fade-up lf-delay-3 mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-xs sm:text-sm text-slate-300"
                    data-testid="hero-trust-row"
                >
                    <span className="inline-flex items-center gap-2">
                        <ShieldCheck
                            size={16}
                            style={{ color: "var(--lf-green-light)" }}
                        />
                        Entidad oficial regulada
                    </span>
                    <span className="inline-flex items-center gap-2">
                        <ScaleIcon
                            size={16}
                            style={{ color: "var(--lf-green-light)" }}
                        />
                        Gestión transparente
                    </span>
                    <span className="inline-flex items-center gap-2">
                        <HeartHandshake
                            size={16}
                            style={{ color: "var(--lf-green-light)" }}
                        />
                        Bienestar social
                    </span>
                </div>
            </div>
        </div>
    </section>
);
